<div class="form-item" [ngClass]="'form-field-'+field.type">
  <nav class="form-field-menu artwork-link-menu" >
    <div class="toggle" (click)="toggleMenu()">
      <span title="Open Menu"></span>
    </div>
    

    <ul [hidden]="!open" class="artwork-link-submenu" >
      <!-- first: the basic field three dot menu items. -->
       <ng-container *ngIf="!filtersOpen">
          <li *ngFor="let item of fieldMenu | sortByMenuOrder" 
            [ngClass]="{'really-remove': item.key === MENU_REALLY_REMOVE,
                        'confirmation-remove': itemMouseDown && item.key === MENU_REMOVE_WITH_CONFIRM }"
            (mousedown)="startClick(item.key, $event)"
            (mouseup)="endClick(item.key, $event)"
            (click)="onMenuClick(item.key)">
            <core-helpers-navigation-three-dots-menu-icon [icon]="item.icon"></core-helpers-navigation-three-dots-menu-icon>
            <span class="menu-title" >{{item.title}}</span>
          </li>
       </ng-container>
       <!-- second sub menu list of filter -->

       <ng-container *ngIf="filtersOpen && selectedFilter == ''">
        <li *ngIf="dependencies && dependencies.length > 0" (click)="onDynamicFilterAdd()" class="link-submenu-li">
          <span class="menu-title" >Dynamic Filter</span>
        </li>
        <li *ngFor="let filter of filtersMenu | sortByMenuOrder" (click)="onSelectFilter(filter.key)" class="link-submenu-li">
          <span class="menu-title" >{{filter.title}}</span>
        </li>
       </ng-container>

      <!-- specific filters to add in the field -->
       <!-- TODO pending to add dynamic filter depending in other fields. -->
       <li class="link-submenu" *ngIf="selectedFilter == 'label'" >
        <core-custom-forms-helpers-search-filters-labels-main
          [available]="availableLabels"
          [applied]="[]"
          (apply)="onFilterApply($event)"
        ></core-custom-forms-helpers-search-filters-labels-main>
       </li>
       <li class="link-submenu" *ngIf="selectedFilter == 'status'">
        <core-custom-forms-helpers-search-filters-status-main
          [available]="availableStatus"
          [applied]="[]"
          (apply)="onFilterApply($event)"
        ></core-custom-forms-helpers-search-filters-status-main>
       </li>
    </ul>
     
  </nav>

  <div  class="form-item-fields" [ngClass]="{'invalid-field': field.label == ''}">
    <input type="text" [ngModel]="field.label" [placeholder]="placeholder" (ngModelChange)="onFieldChange($event)">
    <ng-container *ngIf="(field.dynamic_field?.length == 0  && 
                  field.tag_filter?.length == 0  &&  
                  field.status_filter === null)">
     
      <!-- not warning for now -->   
      <!-- 
      <div class="empty-filters">
        <core-helpers-box-alert-message-icon
          [text]="'There are currently no filters on this field, you can add one now.'"
          [icon]="''"
        ></core-helpers-box-alert-message-icon>
      </div> 
      <span class="advice"><strong>Add filters?</strong> Use the menu &#x2B06;</span>
      -->
    </ng-container>
  </div>
  <!-- Filters selected section -->
  <ng-container>
    <div class="artwork-link-filters">
      <!-- Filters section for dinamic field -->
      <ng-container *ngIf="field.dynamic_field?.length > 0">
        <label>Dynamic Field Filter{{field.dynamic_field?.length > 1? 's':''}}</label>
        <ul class="dynamic-filter">
          <li *ngFor="let dField of field.dynamic_field | sortByMenuOrder; index as idx">
            <div class="object-selector">
              <core-helpers-forms-key-select
                [label]="''"
                [options]="dependenciesItems"
                [placeholder]="'Choose One Field'"
                [optionSelected]="field.dynamic_field[idx] != '' ? field.dynamic_field[idx] : null "
                (actionSelectItem)="updateDynamicField(idx, $event)"
              ></core-helpers-forms-key-select>
            </div>
            <!-- remove/really action here -->
            <span title="Remove" class="field-option field-option-remove" [hidden]="dynamicIsReally(idx)" (click)="removeDynamic(idx, dField)"> <em>Remove</em></span>
            <span title="Really?" class="field-option field-option-really" [hidden]="!dynamicIsReally(idx)" (click)="reallyRemoveDynamic(idx, dField)"> <em>Really?</em> </span>
          </li>
        </ul>
      </ng-container>
      <!-- Filters section for tags -->
      <ng-container *ngIf="field.tag_filter?.length > 0">
        <label>Static Tag Filter{{field.tag_filter?.length > 1? 's':''}}</label>
        <ul class="tag-filter">
          <li *ngFor="let labelId of field.tag_filter">
            <!-- remove tag action here -->
             <ng-container *ngIf="getTag(labelId)">
                <core-label-action [label]="getTag(labelId)" (actionClick)="removeTag($event)"></core-label-action>
              </ng-container>
          </li>
        </ul>
      </ng-container>
      <!-- Filters section for tags -->
      <ng-container *ngIf="field.status_filter && getStatus(field.status_filter)">
        <label>Static Status Filter</label>
        <div class="status-filter">
          <!-- remove/really action here -->
          <span class="status" title="Artwork status: {{getStatus(field.status_filter).name}}" [style.background-color]="getStatus(field.status_filter).color">{{getStatus(field.status_filter).name}}</span>
          <span title="Remove" class="field-option field-option-remove" [hidden]="removingStatus" (click)="removeStatus()">
            <em>Remove</em></span>
          <span title="Really?" class="field-option field-option-really" [hidden]="!removingStatus" (click)="reallyRemoveStatus()">
            <em>Really?</em> </span>
        </div>
      </ng-container>
    </div>
  </ng-container>
  
  <div class="field-mandatory">
    <core-helpers-forms-input-checkbox
      [label]="'Make field mandatory'"
      [form]="form"
      [defaultChecked]="field.mandatory"
      (checkedChange)="onMandatoryChange($event)"
    ></core-helpers-forms-input-checkbox>
  </div>
</div>